import type React from 'react';
import SvgMaskIcon from '../components/SvgMaskIcon';

interface RoseMarkProps {
    width?: number;
    height?: number;
    className?: string;
    style?: React.CSSProperties;
    color?: string;
}

// The four-petal mark alone, i.e. RoseLogo without the wordmark.
const INNER =
    '<path d="M349.998 125.5C349.73 249.536 249.098 350.003 125 350.003C84.0091 350.003 45.5787 339.041 12.4795 319.889L96.1299 175.003C113.993 144.063 147.006 125.003 182.732 125.003L349.998 125.003V125.5Z" fill="#000"/>' +
    '<path d="M125.496 350.012C249.532 350.28 350 450.911 350 575.01C350 616.001 339.036 654.43 319.885 687.529L175 603.88C144.06 586.017 125 553.004 125 517.277L125 350.012L125.496 350.012Z" fill="#000"/>' +
    '<path d="M350.002 574.325C350.366 450.372 450.961 350 575 350C615.991 350 654.42 360.963 687.52 380.114L603.869 525C586.006 555.94 552.993 575 517.267 575L350.002 575L350.002 574.325Z" fill="#000"/>' +
    '<path d="M574.503 349.988C450.467 349.72 350 249.089 350 124.99C350 83.9994 360.963 45.5698 380.114 12.4707L525 96.1201C555.94 113.983 575 146.996 575 182.723L575 349.988L574.503 349.988Z" fill="#000"/>';

const RoseMark: React.FC<RoseMarkProps> = ({
    width,
    height,
    className,
    style,
    color = 'currentColor',
}) => (
    <SvgMaskIcon
        viewBox="0 0 700 700"
        inner={INNER}
        width={width}
        height={height}
        aspectRatio="1 / 1"
        color={color}
        className={className}
        style={style}
    />
);

export default RoseMark;
